<svg
  class="shrink-0"
  [class]="className"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  aria-hidden="true"
>
  @for (path of paths[name] || paths.dashboard; track path) {
    <path [attr.d]="path" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
  }
</svg>
